// @flow
import * as MaterialTabs from './material'

// Types
import type { Props } from './material'

export const TabsContainer = {
  ...MaterialTabs.TabsContainer,
  borderBottom: 'none',
}

export const TabContainer = (props: Props) => {
  const { $palette, $active, $activeTabColor } = props

  const background = $activeTabColor
    ? $palette($activeTabColor)
    : $palette('black').setAlpha(0.4)
  const inactiveBg = background.clone().setAlpha(background.getAlpha() * 0.5)

  return {
    ...MaterialTabs.TabContainer({
      ...props,
      $tabColor: background,
      $activeTabColor: background,
    }),
    ':focus': $active
      ? {}
      : {
          backgroundColor: `${inactiveBg
            .clone()
            .setAlpha(background.getAlpha() * 0.8)}`,
        },
    ':hover': $active
      ? {}
      : {
          backgroundColor: `${inactiveBg
            .clone()
            .setAlpha(background.getAlpha() * 0.8)}`,
        },
    padding: '8px',
    borderTop: 'none',
    color: 'white',
    borderRadius: '4px 4px 0 0',
    backgroundColor: $active ? `${background}` : `${inactiveBg}`,
  }
}
